module.exports = __webpack_public_path__ + "img/bgc11.c0d8c76a.png";